import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { Questionnaire, QuestionnaireDefinition } from "../common/models";
import { QuestionnaireTaskView } from "../common/QuestionnaireTaskView";


const Definition: QuestionnaireDefinition = {
  name: 'PANAS',
  key: 'panasQuestionnaire',
  title: 'PANAS',
  description: '',
  cohort: 'mood',
  type: 'questionnaire',
  estimatedCompletionTime: '1:00',
  groups: [
    {
      key: 'panas',
      // Note: We need to display multiple lines in the description.
      content: 
      <>
        <Typography>Thinking about yourself and how you normally feel, to what extent do you generally feel?</Typography>
        <Typography>Interval measure: never 1 2 3 4 5 always</Typography>
      </>,
      questions: [
        {
          // The key is from REDCap.
          key: 'upset',
          type: 'multiple-choice',
          question: 'Upset',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'hostile',
          type: 'multiple-choice',
          question: 'Hostile',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'alert',
          type: 'multiple-choice',
          question: 'Alert',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'ashamed',
          type: 'multiple-choice',
          question: 'Ashamed',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'inspired',
          type: 'multiple-choice',
          question: 'Inspired',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'nervous',
          type: 'multiple-choice',
          question: 'Nervous',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'determined',
          type: 'multiple-choice',
          question: 'Determined',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'attentive',
          type: 'multiple-choice',
          question: 'Attentive',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'afraid',
          type: 'multiple-choice',
          question: 'Afraid',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is from REDCap.
          key: 'active',
          type: 'multiple-choice',
          question: 'Active',
          options: [
            { key: '1', displayName: '1' },
            { key: '2', displayName: '2' },
            { key: '3', displayName: '3' },
            { key: '4', displayName: '4' },
            { key: '5', displayName: '5' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        }
      ]
    }
  ]
};

export const PANASDefinition = Definition;

export const PANAS = ({onCompletion}: {onCompletion: () => void}) => {
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(() => ({
    id: 'panasQuestionnaires',
    ...Definition,
    status: 'in-progress',
    startedAt: new Date().toISOString(),
    completedAt: null,
  }));

  console.log('PANAS component rendered', questionnaire);

  const handleOnCompletion = () => {
    console.log('PANAS completed');

    onCompletion();
  };

  const handleOnChange = (questionnaire: Questionnaire) => {
    console.log('questionnaire', questionnaire);
    setQuestionnaire(questionnaire);
  }

  console.log('PANAS component rendered', questionnaire);

  return (
    <div>
      <QuestionnaireTaskView questionnaire={questionnaire} onChange={handleOnChange} onCompletion={handleOnCompletion  } />
    </div>
  );
}

